import axios from 'axios';
import AppSettings from '../../../core/AppSettings';

// getVehicleInfoByVin
export const getVehicleInfoByVin = (vin) => {
    const url = '/wcs/resources/store/' + AppSettings.storeId + '/Search/VehicleInfo/byVIN/' + vin + '?responseFormat=json';
    return axios.get(url).then(response => response.data).catch(error => console.log("error", error));
}